import { RECEIVE_DEDUCTION_SUMMARY, REQUEST_DEDUCTION_SUMMARY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_DEDUCTION_SUMMARY:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_DEDUCTION_SUMMARY: {
            return { ...state, ...data, isFetching: false }
        }

        default:
            return state
    }
}
